
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/contact",
      function () {
        return require("private-next-pages/events/contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/contact"])
      });
    }
  